import React from "react";

//--------Styles--------
import "./styles/dark-mode.scss";
import "./styles/style.scss";
import "./styles/project_cards.scss";
import "./styles/timesheet_style.scss";

import AppThemeProvider from "./components/AppThemeProvider";
import { StyleContextProvider } from "./context/styleContext";
import AppMainArea from "./AppMainArea";

function App() {
  return (
    <div id="wrapper" className="app">
      <StyleContextProvider>
        <AppThemeProvider>
          <AppMainArea />
        </AppThemeProvider>
      </StyleContextProvider>
    </div>
  );
}

export default App;
